// Upper bound sent when a slider's max handle sits at its "+" end ("2500m+", "24h+"), so the
// search has no real ceiling. Fits Typesense's int32 fields.
export const OPEN_ENDED_UPPER_BOUND = 99999999;

export interface CommunityRange {
  field: string;
  selectedMin: number;
  selectedMax: number;
  rangeMin: number;
  rangeMax: number;
  // Multiplier from slider units to search units, e.g. 60 for hours → duration_minutes.
  scale?: number;
}

// Typesense filter clause for a community range slider, or '' when the slider is untouched.
export function communityRangeClause({ field, selectedMin, selectedMax, rangeMin, rangeMax, scale = 1 }: CommunityRange): string {
  if (selectedMin <= rangeMin && selectedMax >= rangeMax) return '';

  const lower = Math.round(selectedMin * scale);
  const upper = selectedMax >= rangeMax ? OPEN_ENDED_UPPER_BOUND : Math.round(selectedMax * scale);
  return `&&${field}:[${lower}..${upper}]`;
}
